export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n8_eternite.ac1bcf29.svg";